import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { store } from '../../store/store';


const baseUrl = process.env.REACT_APP_base_URL;

export const getBsiCoLabSolutionList  = createApi({
    reducerPath: 'getBsiCoLabSolutionList',
    baseQuery: fetchBaseQuery({
      baseUrl: baseUrl,
      prepareHeaders: (headers) => {
        // const token = useSelector((state)=> state.user.token)
        const token = store.getState().user.token;
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
    }),
    endpoints: (builder) => ({
      fetchSolutionProviderRequirementBoard: builder.query({
        query: ({sort,solution_name}) => ({
          url: `requirement_boards/solution-provider?solution_name=${solution_name}&sort=${sort}`,
          method: 'GET',
        }),
        transformResponse: (response) => {
          if(response.status != "error"){
            return response.data
          }else{
           return  response = [];
          }
        },
        refetchOnWindowFocus: true,
        // retry: RetryOnError,
        onError: (error) => {
          console.error('Fetch user details error:', error);
          // Handle error cases as per your application's requirements
        },
      })
    })
})


export const { useFetchSolutionProviderRequirementBoardQuery } = getBsiCoLabSolutionList;
export default getBsiCoLabSolutionList;